.list-item:not(:last-child) {
    padding-bottom: 16px;
}

.empty-state-image {
    width: 200px;
}
